<template>
  <section>
    <Slogn title1="「合作·互助·創新」理念" title2="「共創·共富·共享」目標" sub-title="Join Hands to Create the Future." />
    <el-row :gutter="20">
      <el-col :span="24">
        <div class="banner" />
      </el-col>
      <el-row>
        <el-col :xs="24" :md="24" align="center">
          <p>
            合作社組織價值：互助，責任，民主，平等，公平，團結倫理價值：值得信任，社會責任，關懷他人，開放接納
          </p>
          <p class="slogn">
            七大原則：
          </p>
        </el-col>
      </el-row>
      <el-col :xs="24" :md="12">
        <MarkComponent>
          <p class="title">第1原則</p>
          <p class="content">
            自願與公開的社員制
          </p>
        </MarkComponent>
        <MarkComponent>
          <p class="title">第2原則</p>
          <p class="content">
            社員的民主治理
          </p>
        </MarkComponent>
        <MarkComponent>
          <p class="title">第3原則</p>
          <p class="content">
            社員的經濟參與
          </p>
        </MarkComponent>
        <MarkComponent>
          <p class="title">第4原則</p>
          <p class="content">
            自治與自立
          </p>
        </MarkComponent>
      </el-col>
      <el-col :xs="24" :md="12">
        <MarkComponent>
          <p class="title">第5原則</p>
          <p class="content">
            教育、訓練與宣導
          </p>
        </MarkComponent>
        <MarkComponent>
          <p class="title">第6原則</p>
          <p class="content">
            社間合作
          </p>
        </MarkComponent>
        <MarkComponent>
          <p class="title">第7原則</p>
          <p class="content">
            關懷地區社會
          </p>
        </MarkComponent>
      </el-col>
    </el-row>
  </section>
</template>
<script>
import Slogn from '@/components/Slogn'
import MarkComponent from '@/components/MarkComponent.vue'

export default {
  components: {
    Slogn,
    MarkComponent
  }
}
</script>

<style scoped lang="scss">
.banner {
  background-image: url('../../assets/img/career-mo.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: right;
  width: 100vw;
  height: 30vh;
  margin: 0 -20px 20px;
  @include minWidth992 {
    width: 100%;
    margin: 0 0 20px;
    background-image: url('../../assets/img/career-pc.png');
  }
}
::v-deep .mark::before {
  height: 80px;
}

.title {
  font-size: 22px;
  color: $deepBlue;
  line-height: 1;
  margin: 0;
}

.content {
  color: $deepGrey;
  font-size: 16px;
  margin: 12px 0 0;
}

p.slogn {
    color: $deepBlue;
    margin-bottom:0;
    @include minWidth992 {
      font-size: 20px;
      margin-bottom:20px;
    }
  }

</style>
